import { sqliteTable, text, integer } from "drizzle-orm/sqlite-core";
import type { AccessTicket } from "@libs/wire";
import { timestamps } from "../utils/fields";

// Per-entity-ID durable cache for access wire shape. Mirrors `cached_songs`
// / `cached_albums` / `cached_artists` — see `cached_artists.ts` for design
// notes. Single-column PK on `accessId`. Pre-warmed by feed-style infinite
// queries (`useArtistStoreAccesses`, `useAllAccessesPaginated`) via
// `meta.decompose` so subsequent `useAccess(id)` reads hit cache.
export const cachedAccesses = sqliteTable("cached_accesses", {
  ...timestamps,
  accessId: text("access_id").primaryKey(),
  // The wire shape (the discriminated union of `event` + `music` access
  // variants from `functions/api/schema.ts`) is non-trivial and zod-parsed
  // on read in `withEntityCache`, so we keep $type here for editor
  // help/IntelliSense and let the runtime parse confirm the shape.
  data: text("data", { mode: "json" }).notNull().$type<AccessTicket>(),
  fetchedAt: integer("fetched_at", { mode: "timestamp_ms" }).notNull(),
});

export type CachedAccessRow = typeof cachedAccesses.$inferSelect;
